import React from "react";
import PropTypes from "prop-types";
import {
  RiskLabel,
  ContainerDiv,
  ClipDiv1,
  ClipDiv2,
  ClipDiv3,
  ClipDiv4,
  ClipDiv5,
  RiskText,
  RiskTextNext
} from "./styles";

let color = -1;
let riskColor = -1;
export default function ClipDivision(props) {
  (function ColorAssigner() {
    if (props.tab === "mi") {
      color = "#69923a";
    } else if (props.tab === "ps") {
       color = "#006778";
    } else if (props.tab === "pb") {
      color = "#69923a";
    } else if (props.tab === "vdi") {
       color = "#9F6AB8";
    }
  })();
  (function RiskAssigner() {
    if (props.risk === "1") {
      riskColor = color;
    } else if (props.risk === "2") {
      riskColor = color;
    } else if (props.risk === "3") {
      riskColor = color;
    } else if (props.risk === "4") {
      riskColor = color;
    } else if (props.risk === "5") {
      riskColor = color;
    }
  })();
  return (
    <div>
      <ContainerDiv>
        <ClipDiv1 color={props.risk === "1" ? riskColor : -1}>1</ClipDiv1>
        <ClipDiv2 color={props.risk === "2" ? riskColor : -1}>2</ClipDiv2>
        <ClipDiv3 color={props.risk === "3" ? riskColor : -1}>3</ClipDiv3>
        <ClipDiv4 color={props.risk === "4" ? riskColor : -1}>4</ClipDiv4>
        <ClipDiv5 color={props.risk === "5" ? riskColor : -1}>5</ClipDiv5>
      </ContainerDiv>
      <RiskLabel>
        <RiskText>
          Less risk
          <br />
          Short-term
        </RiskText>
        <RiskTextNext>
          More risk
          <br />
          Long-term
        </RiskTextNext>
      </RiskLabel>
    </div>
  );
}

ClipDivision.propTypes = {
  risk: PropTypes.string,
  tab: PropTypes.string
}
